export const audits = {
	navTitle: "Audit",
	title: "Audit Report",
	subTitle: "Detailed report of actions performed through the dashboard and Admin panel",
	filters: {
		employeePlaceholder: "Filter by employee",
		typePlaceholder: "Filter by type",
		functionPlaceholder: "Filter by function",
	},
	table: {
		columns: {
			date: "Date",
			employee: "Employee",
			place: "Place",
			organization: "Organization",
			type: "Type",
			function: "Function",
			observation: "Observation",
			params: "Params",
			createdAt: "Created At",
		},
		viewParams: "View",
		paramsModalTitle: "Parameters",
		exportFilename: "Audits",
		exportTitle: "Audits Report",
	},
};
